import { FunctionComponent, useEffect, useRef, useState } from 'react'
import { Alert, Spinner } from 'react-bootstrap'
import { Link, useSearchParams } from 'react-router-dom'

import AuthCardLayout from 'components/layout/auth/authCardLayout'
import * as userApi from '../api.client'
import { completeLogin, LoginRoleNotAllowedError } from '../completeLogin'
import { UserRole } from '../types'

export const ExternalAuth: FunctionComponent<{
  handleSuccessfulLogin: () => void
}> = ({ handleSuccessfulLogin }) => {
  const [searchParams] = useSearchParams()
  const [error, setError] = useState<string | null>(null)
  const authenticatingRef = useRef(false)

  useEffect(() => {
    const accessToken = searchParams.get('access_token')

    if (!accessToken) {
      setError('Token de acesso não encontrado.')
      return
    }

    if (authenticatingRef.current) {
      return
    }

    authenticatingRef.current = true

    const authenticate = async () => {
      try {
        const jwt = await userApi.authenticateWithExternalToken(accessToken)
        await completeLogin(jwt, handleSuccessfulLogin, {
          allowedRoles: [UserRole.DOCTOR],
        })
      } catch (err) {
        console.error(err)
        setError(
          err instanceof LoginRoleNotAllowedError
            ? err.message
            : 'Não foi possível autenticar. O token pode estar expirado ou inválido.'
        )
        authenticatingRef.current = false
      }
    }

    authenticate()
  }, [searchParams, handleSuccessfulLogin])

  return (
    <AuthCardLayout title="Acessar o Clic-repasse">
      {error ? (
        <>
          <Alert variant="danger">{error}</Alert>
          <Link to="/login">Ir para o login</Link>
        </>
      ) : (
        <div className="d-flex align-items-center gap-3 text-muted">
          <Spinner animation="border" size="sm" />
          Autenticando…
        </div>
      )}
    </AuthCardLayout>
  )
}

export default ExternalAuth
